








import { Vue, Component, Prop } from "vue-property-decorator";
import {
  ClientInfo,
  EContentType,
  EDocumentTypeMap,
  PersonInfo,
} from "@/types";
import { EDomicileTypes, EUserTypes } from "@/pagesCom/ClientInfo/index.dto";
import FormSection, { IFormSection } from "./components/FormSection.vue";
import { namespace } from "vuex-class";
import { ECountryCode } from "@/pagesCom/ClientInfo/index.dto";
import { removePlusSign } from "@/utils/common-utils";

const configModule = namespace("config");

@Component({
  components: {
    FormSection,
  },
})
export default class PersonsInCharge extends Vue {
  @Prop({ type: Object, default: () => ({}) }) info!: ClientInfo;
  @configModule.Getter("isJKTDashboard") isJKTDashboard!: boolean;

  authorizedSignList = this.info.authorizedSignatory;

  billingPicList = this.info.financePIC;

  generateFileFields(PICobj: PersonInfo) {
    const withFiles = !PICobj.isDirector;

    if (withFiles) {
      return {
        [EDocumentTypeMap.POA_DOC]: "POA",
        [EDocumentTypeMap.ID_DOC]: "ID",
      };
    } else if (this.isJKTDashboard) {
      return {
        [EDocumentTypeMap.DIR_ID_DOC]: "ID",
      };
    } else if (
      this.info.country == ECountryCode.PH &&
      this.isCompany &&
      this.isLocalDomicile
    ) {
      return {
        [EDocumentTypeMap.POA_DOC]: "POA",
      };
    } else {
      return {};
    }
  }

  formatPICToFormSection(
    titleBase: string,
    arrOfPIC?: PersonInfo[]
  ): IFormSection[] {
    if (!arrOfPIC) return [];

    const isNeedCounter = arrOfPIC.length > 1;
    return arrOfPIC.map((PICobj, index) => {
      const keyOfPersonInfo = Object.keys(PICobj) as (keyof PersonInfo)[];

      const keyToLabelMap = {
        fullName: "FULL NAME",
        role: "ROLE",
        phoneNumber: "PHONE NO.",
        email: "EMAIL",
        ...this.generateFileFields(PICobj),
      };

      return {
        title: isNeedCounter ? `${titleBase} ${index + 1}` : titleBase,
        data: keyOfPersonInfo
          .filter((key) => keyToLabelMap[key as keyof typeof keyToLabelMap])
          .map((key) => {
            const isFile = [
              EDocumentTypeMap.POA_DOC,
              EDocumentTypeMap.ID_DOC,
              EDocumentTypeMap.DIR_ID_DOC,
            ].includes(key as EDocumentTypeMap);

            const getKeyValue = () => {
              if (isFile) {
                return [PICobj[key]];
              } else if (key === "phoneNumber") {
                const countryCode = PICobj.phoneNumberCountryCode
                  ? `+${removePlusSign(PICobj.phoneNumberCountryCode)}`
                  : "";
                return `${countryCode}${PICobj[key]}`;
              } else {
                return PICobj[key] || "N/A";
              }
            };

            return {
              label: keyToLabelMap[key as keyof typeof keyToLabelMap],
              content: getKeyValue(),
              type: isFile ? EContentType.FILE : EContentType.TEXT,
              visible: true,
            };
          }),
      } as IFormSection;
    });
  }

  get leftSection(): IFormSection[] {
    return this.info.userType === EUserTypes.COMPANY
      ? this.formatPICToFormSection(
          "Authorized Signatory",
          this.info.authorizedSignatory
        )
      : this.formatPICToFormSection("Billing PIC", this.info.financePIC);
  }

  get rightSection(): IFormSection[] {
    return this.info.userType === EUserTypes.COMPANY
      ? this.formatPICToFormSection("Billing PIC", this.info.financePIC)
      : [];
  }

  get isCompany(): boolean {
    return this.info.userType === EUserTypes.COMPANY;
  }

  get isLocalDomicile(): boolean {
    return this.info.domicileType === EDomicileTypes.LOCAL;
  }
}
